import React from "react";

type SheetProps = {
  open: boolean;
  onOpenChange?: (open: boolean) => void;
  children: React.ReactNode;
};

export const Sheet: React.FC<SheetProps> = ({
  open,
  onOpenChange,
  children,
}) => {
  return (
    <>
      {open && (
        <>
          <div
            className="fixed inset-0 z-[200] bg-black/40"
            onClick={() => onOpenChange?.(false)}
            aria-hidden="true"
          />
          {children}
        </>
      )}
    </>
  );
};

type SheetContentProps = {
  side?: "right" | "left" | "top" | "bottom";
  className?: string;
  children: React.ReactNode;
};

export const SheetContent: React.FC<SheetContentProps> = ({
  side = "right",
  className = "",
  children,
}) => {
  const sideClasses =
    side === "right"
      ? "right-0 top-0 h-full w-[90%] max-w-[600px]"
      : side === "left"
        ? "left-0 top-0 h-full w-[90%] max-w-[600px]"
        : side === "top"
          ? "top-0 left-0 w-full h-1/2"
          : "bottom-0 left-0 w-full h-1/2";
  return (
    <div
      className={`fixed z-[201] bg-popover text-popover-foreground shadow-xl border border-border ${sideClasses} overflow-auto ${className}`}
      role="dialog"
      aria-modal="true"
    >
      {children}
    </div>
  );
};

type SheetHeaderProps = {
  className?: string;
  children: React.ReactNode;
};

export const SheetHeader: React.FC<SheetHeaderProps> = ({
  className = "",
  children,
}) => {
  return (
    <div className={`px-4 py-3 border-b border-border ${className}`}>
      {children}
    </div>
  );
};

type SheetTitleProps = {
  className?: string;
  children: React.ReactNode;
};

export const SheetTitle: React.FC<SheetTitleProps> = ({
  className = "",
  children,
}) => {
  return <h2 className={`text-base font-semibold ${className}`}>{children}</h2>;
};

export default Sheet;
